<template>
    <div class="pre_registration">
        <v-header></v-header>
        <v-headers></v-headers>
        <section class="container">
            <picture>
                <source
                    class="bg"
                    srcset="../assets/images/mobile/pre_registration/pre_registration_bg.png"
                    media="(max-width: 600px)"
                />
                <img
                    class="bg"
                    src="../assets/images/pre_registration/bg.jpg"
                    ondragstart="return false;"
                    alt
                />
            </picture>
            <div class="cover">
                <div class="title_bar">
                    <img
                        class="logo"
                        src="../assets/images/Mahjong_logo.png"
                        ondragstart="return false;"
                        alt
                    />
                    <img src="../assets/images/pre_registration/title.png" alt class="title" />
                </div>
                <img
                    class="subtitle"
                    src="../assets/images/pre_registration/Pre-registration.png"
                    ondragstart="return false;"
                    alt
                />
            </div>
            <p>事前登録期間：5月15日～DMM版リリース日</p>
            <a class="img_s" @click="request">
                <img src="../assets/images/sxdl.png" alt />
            </a>
        </section>
        <v-footer></v-footer>
    </div>
</template>

<script>
import Footer from "@/components/footer.vue";
import Header from "@/components/dmmheader.vue";
import Headers from "@/components/dmmnavi_header.vue";
// import { Base64 } from "js-base64";
// import sha1 from "js-sha1";
// import moment from "moment-timezone";

export default {
    name: "pre_registration",
    components: {
        "v-footer": Footer,
        "v-header": Header,
        "v-headers": Headers
    },
    data: () => ({
    }),
    created() {
        console.log("VUE_APP_BASEURL:", process.env.VUE_APP_BASEURL);
        console.log("VUE_APP_FinishPageUrl:", process.env.VUE_APP_FinishPageUrl);
        console.log("VUE_APP_CallBack_url:", process.env.VUE_APP_CallBack_url);
    },
    mounted() {},
    watch: {},
    computed: {
    },
    methods: {
        request() {
            this.axios.get("/getconfig").then(v=> {
                if(v.retcode == 2000) {
                    window.location.href = `${process.env.VUE_APP_BASEURL}?p=${v.data.p}`
                } else {
                    console.log("get config error")
                }
            }).then(e => {
                console.log(e)
            })
        }
    }
};
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: 0;
    padding-bottom: 43.85%;
    position: relative;
    overflow: hidden;
    font-family: inherit;
    @media screen and (max-width: 600px) {
        height: 0;
        padding-bottom: 170.14%;
    }
    .bg {
        width: 100%;
    }

    .cover {
        width: 60%;
        text-align: center;
        position: absolute;
        top: pxTorem(60px);
        left: 50%;
        transform: translateX(-50%);

        @media screen and (max-width: 600px) {
            width: 90%;
        }
        @media (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
            width: 90%;
            top: pxTorem(20px);
        }
        @media (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
            width: 80%;
            top: pxTorem(30px);
        }

        .title_bar {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;

            .logo {
                width: 9rem;
                position: absolute;
                left: -0.6rem;
                top: 1.1rem;
                @media screen and (max-width: 600px) {
                    display: none;
                }
            }

            .title {
                width: pxTorem(540px);
                margin-top: pxTorem(30px);
                margin-left: pxTorem(160px);
                @media screen and (max-width: 600px) {
                    width: pxTorem(600px);
                    margin-top: pxTorem(0px);
                    margin-left: 0;
                }
            }
        }

        .subtitle {
            width: pxTorem(498px);
            margin-top: pxTorem(-20px);
            margin-left: pxTorem(120px);

            @media screen and (max-width: 600px) {
                width: pxTorem(400px);
                margin-top: pxTorem(0px);
                margin-left: 1rem;
            }
            @media (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
                width: pxTorem(370px);
            }
        }

        .btn_wrap {
            position: relative;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            width: pxTorem(390px);
            margin-bottom: pxTorem(13px);
            margin-top: pxTorem(20px);
            cursor: pointer;

            @media screen and (max-width: 600px) {
                margin-top: MpxTorem(20px);
            }

            .pre_button {
                // width: 48%;
                height: pxTorem(47px);

                &.pre_email {
                    margin-right: pxTorem(24px);
                    margin-bottom: pxTorem(21px);
                }

                &.pre_twitter {
                    margin-bottom: pxTorem(21px);
                }

                &.pre_google {
                    margin-right: pxTorem(27px);
                }

                img {
                    height: 100%;
                }
            }
        }

        .subtip {
            color: #fff;
            font-size: pxTorem(14px);
            letter-spacing: pxTorem(1px);
            margin-bottom: pxTorem(30px);
            @media screen and (max-width: 600px) {
                font-size: MpxTorem(14px);
                margin-top: MpxTorem(10px);
                margin-bottom: MpxTorem(30px);
            }
        }

        .other_wrap {
            display: flex;
            justify-content: center;
            margin-bottom: pxTorem(16px);
            @media screen and (max-width: 600px) {
                margin-top: MpxTorem(20px);
                margin-bottom: MpxTorem(30px);
            }

            .event_box {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                .title {
                    width: pxTorem(270px);
                    margin-top: pxTorem(-25px);
                    @media screen and (max-width: 600px) {
                        width: MpxTorem(250px);
                    }
                }

                .content {
                    color: #fff;
                    font-size: pxTorem(14px);
                    letter-spacing: pxTorem(1px);
                    text-align: left;
                    line-height: 1.2;
                    margin-top: pxTorem(-10px);
                    margin-left: pxTorem(5px);
                    @media screen and (max-width: 600px) {
                        font-size: MpxTorem(13px);
                    }
                }
            }
        }

        .prize_wrap {
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;

            .prize_content {
                display: flex;
                justify-content: center;

                @media screen and (max-width: 600px) {
                    width: 100%;
                }

                .prize_box {
                    width: pxTorem(115px);

                    &:not(:last-child) {
                        margin-right: pxTorem(14px);
                    }

                    @media screen and (max-width: 600px) {
                        width: pxTorem(80px);
                        &:not(:last-child) {
                            margin-right: MpxTorem(14px);
                        }
                    }

                    .players {
                        color: #fff;
                        font-family: "okayd";
                        font-size: pxTorem(30px);
                        align-items: center;
                        display: flex;
                        justify-content: center;

                        .players_tip {
                            width: pxTorem(20px);
                            margin-left: pxTorem(3px);
                        }
                    }

                    .prize {
                        width: 100%;
                        height: pxTorem(90px);
                        background: url("../assets/images/pre_registration/prize_bg.png")
                            no-repeat center;
                        background-size: cover;
                        position: relative;

                        @media screen and (max-width: 600px) {
                            background-size: cover;
                        }

                        img {
                            width: pxTorem(50px);
                            height: pxTorem(50px);
                            margin-top: pxTorem(10px);
                        }

                        .number {
                            color: #fff;
                            font-family: "okayd";
                            font-size: pxTorem(20px);
                            margin-top: pxTorem(3px);

                            &.right_num {
                                position: absolute;
                                right: pxTorem(8px);
                                top: 26%;
                                @media screen and (max-width: 600px) {
                                    position: relative;
                                    top: 0;
                                    right: 0;
                                }
                                @media (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait),
                                    (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
                                    position: relative;
                                    top: 0;
                                    right: 0;
                                }
                            }
                        }

                        .tip {
                            color: #fff;
                            font-size: pxTorem(11px);
                            margin-top: pxTorem(9px);
                            letter-spacing: 1px;
                            @media screen and (max-width: 600px) {
                                display: none;
                            }
                            @media (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait),
                                (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
                                display: none;
                            }
                        }
                    }

                    .prize_actived {
                        background: url("../assets/images/pre_registration/prize_actived_bg.png");
                        background-size: 100%;
                        @media screen and (max-width: 600px) {
                            background-size: cover;
                        }
                    }
                }
            }

            .processbar {
                width: 160%;
                height: pxTorem(10px);
                background: linear-gradient(
                    to right,
                    #31313118,
                    #313131,
                    #31313118
                );
                position: relative;

                @media screen and (max-width: 600px) {
                    width: 180%;
                }
                @media (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
                    width: 105%;
                }
                @media (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
                    width: 120%;
                }

                .bar {
                    position: absolute;
                    bottom: 0;
                    width: 0;
                    height: pxTorem(10px);
                    background: linear-gradient(to right, #60141f09, #e90927);
                }
            }
        }

        .current_players {
            display: flex;
            justify-content: center;
            align-items: center;

            .current_tip_before {
                height: pxTorem(70px);
                @media screen and (max-width: 600px) {
                    height: MpxTorem(60px);
                }
            }

            .current_tip_after {
                height: pxTorem(70px);
                margin-left: pxTorem(-30px);
                @media screen and (max-width: 600px) {
                    height: MpxTorem(60px);
                }
            }

            .players {
                color: #fff;
                font-family: "okayd";
                font-size: pxTorem(24px);
                margin-right: pxTorem(30px);
                @media screen and (max-width: 600px) {
                    font-size: MpxTorem(20px);
                }
            }
        }

        .news_box {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;

            .title {
                width: pxTorem(100px);
                margin-right: pxTorem(10px);

                @media screen and (max-width: 600px) {
                    width: MpxTorem(90px);
                }
                @media (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
                    width: pxTorem(180px);
                }
            }

            .icon_box {
                display: flex;
                justify-content: center;

                .facebook_btn {
                    width: pxTorem(30px);
                    height: pxTorem(30px);
                    background: url("../assets/images/pre_registration/Facebook.png")
                        no-repeat;
                    background-size: 100%;
                    margin-right: pxTorem(25px);
                    cursor: pointer;
                    @media screen and (max-width: 600px) {
                        width: MpxTorem(40px);
                        height: MpxTorem(40px);
                    }
                }

                .twitter_btn {
                    width: pxTorem(30px);
                    height: pxTorem(30px);
                    background: url("../assets/images/pre_registration/Twitter.png")
                        no-repeat;
                    background-size: 100%;
                    cursor: pointer;
                    @media screen and (max-width: 600px) {
                        width: MpxTorem(35px);
                        height: MpxTorem(35px);
                    }
                }
            }
        }
    }
    p {
        position: absolute;
        font-size: pxTorem(14.12px);
        font-family: inherit;
        color: white;
        left: pxTorem(576px);
        top: pxTorem(262px);
        @media screen and (max-width: 600px) {
            left: 50%;
            margin-left: pxTorem(-136px);
        }
    }
    .img_s {
        width: pxTorem(500px);
        position: absolute;
        left: pxTorem(409px);
        top: pxTorem(342px);
        cursor: pointer;
        @media screen and (max-width: 600px) {
            left: 50%;
            top: pxTorem(500px);
            width: pxTorem(500px);
            margin-left: pxTorem(-250px);
        }
        img {
            width: 95%;
            @media screen and (max-width: 600px) {
                width: 100%;
            }
        }
    }
}

.pre_mask {
    width: 100vw;
    height: 100vh;
    background: #000a21a1;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;

    .box {
        width: pxTorem(389px);
        height: pxTorem(211px);
        border: 1px solid #052b6b;
        background: #131313f3;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        font-family: "DomBoldBt";
        color: #fff;
        text-align: center;

        @media screen and (max-width: 600px) {
            width: MpxTorem(320px);
            height: MpxTorem(211px);
        }
        @media (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
            width: MpxTorem(480px);
            height: MpxTorem(211px);
        }

        .close_btn {
            position: absolute;
            width: pxTorem(40px);
            top: 0;
            right: pxTorem(-50px);
            cursor: pointer;
            @media screen and (max-width: 600px) {
                width: MpxTorem(40px);
                right: MpxTorem(-30px);
            }
        }

        .title {
            margin: pxTorem(40px) 0 pxTorem(40px);
            font-size: pxTorem(20px);
            @media screen and (max-width: 600px) {
                margin: MpxTorem(50px) 0;
                font-size: MpxTorem(16px);
            }
        }

        .msg {
            line-height: 1.5;
            font-size: pxTorem(22px);
            box-sizing: border-box;
            padding: 0 pxTorem(25px);
            @media screen and (max-width: 600px) {
                font-size: MpxTorem(18px);
            }
        }
    }

    .input_email {
        width: pxTorem(634px);
        height: pxTorem(211px);

        @media screen and (max-width: 600px) {
            width: MpxTorem(320px);
            height: MpxTorem(211px);
        }
        @media (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
            width: MpxTorem(480px);
            height: MpxTorem(211px);
        }

        .email_box {
            display: flex;
            width: 85%;
            position: absolute;
            left: 55%;
            top: 50%;
            transform: translate(-50%, -50%);
            flex-direction: column;

            @media screen and (max-width: 600px) {
                width: 90%;
                left: 50%;
            }

            .input_box {
                display: flex;
                align-items: center;
                margin-bottom: pxTorem(10px);

                input {
                    -web-kit-appearance: none;
                    -moz-appearance: none;
                    font-size: pxTorem(13px);
                    width: pxTorem(287px);
                    height: pxTorem(35px);
                    border: 1px solid #fff;
                    border-radius: 0;
                    color: #6a6f77;
                    outline: 0;
                    padding: pxTorem(3px) pxTorem(10px);
                    box-sizing: border-box;
                    margin-right: pxTorem(16px);

                    @media screen and (max-width: 600px) {
                        width: MpxTorem(287px);
                        height: MpxTorem(30px);
                    }

                    &.error {
                        border: 1px solid rgb(235, 29, 63);
                    }
                }

                .confirm_btn {
                    width: pxTorem(115px);
                    height: pxTorem(35px);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background: #ffdb32;
                    border: 1px solid #ffae00;
                    box-sizing: border-box;
                    cursor: pointer;
                    transition: background 0.5s;

                    @media screen and (max-width: 600px) {
                        width: MpxTorem(115px);
                        height: MpxTorem(30px);
                    }

                    img {
                        display: block;
                        width: 80%;
                    }

                    &:hover {
                        background: #d1af17;
                    }
                }
            }

            .sel_wrap {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                box-sizing: border-box;
                margin-bottom: pxTorem(10px);

                &.sel_first {
                    margin-bottom: pxTorem(15px);
                }

                @media screen and (max-width: 600px) {
                    margin-bottom: MpxTorem(10px);
                    &.sel_first {
                        margin-bottom: MpxTorem(20px);
                    }
                    &.sel_second {
                        align-items: flex-start;
                    }
                }

                .sel_box {
                    width: pxTorem(24px);
                    height: pxTorem(24px);
                    box-sizing: border-box;
                    background: #303030;
                    border: 1px solid #fff;
                    margin-right: pxTorem(5px);
                    cursor: pointer;

                    @media screen and (max-width: 600px) {
                        width: MpxTorem(24px);
                        height: MpxTorem(24px);
                        margin-right: MpxTorem(10px);
                    }

                    &.seled {
                        border: 0;
                        background: url("../assets/images/pre_registration/seled.png")
                            no-repeat;
                        background-size: 100%;
                    }
                }

                .tip {
                    font-size: pxTorem(12px);
                    color: #fff;
                    text-align: left;
                    line-height: 1.2;
                    flex: 1;

                    @media screen and (max-width: 600px) {
                        font-size: MpxTorem(12px);
                    }

                    a {
                        color: #efbe9e;
                        text-decoration: underline;
                    }
                }

                .error_tip {
                    position: relative;

                    &::after {
                        display: block;
                        content: " * プライバシーポリシーを確認してください";
                        margin-left: pxTorem(3px);
                        color: #e30b28;
                        position: absolute;
                        left: 0;
                        top: 100%;

                        @media screen and (max-width: 600px) {
                        }
                    }
                }

                .notices_tip {
                    color: #fff;
                    text-decoration: underline;
                    font-size: pxTorem(12px);
                    margin-left: pxTorem(29px);

                    @media screen and (max-width: 600px) {
                        margin-left: MpxTorem(35px);
                        font-size: MpxTorem(12px);
                    }
                }
            }
        }
    }
}
</style>
